<template>
  <v-card>
    <v-container fluid>
      <v-row justify="center">
        <v-col cols="12" align="center" style="font-size: 20px">
          {{ $t('Record a video for your partners') }}.
        </v-col>
      </v-row>
      <v-row v-if="video" justify="center">
        <v-col cols="12">
          <div class="video-container">
            <iframe id="iframe-video2" class="video-frame" :src="video" frameborder="0" allowfullscreen allow="autoplay" />
          </div>
        </v-col>
      </v-row>
      <v-row v-if="!video" justify="center">
        <v-col cols="12">
          <VideoInput id="videoInput" @videoUploader="uploadPresentationVideo">
          </VideoInput>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col v-if="video" cols="6" align="center">
          <v-btn x-large class="justify-center" color="#2962FF" @click="saveVideo()">
            <v-icon style="margin-right: 5px">
              mdi-content-save-all
            </v-icon>{{ $t('Save') }}
          </v-btn>
        </v-col>
        <v-col cols="12" align="center">
          <v-btn x-large class="justify-center" color="secondary" style="color: black" @click="next()">
            {{ $t('Skip') }} <v-icon style="left: 5px">
              mdi-arrow-right-thin
            </v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" align="center">
          <v-btn x-large class="justify-center" color="secondary" style="color: black" @click="back()">
            <v-icon style="margin-right: 5px">
              mdi-undo-variant
            </v-icon>{{ $t('Back') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import VideoInput from "../components/VideoInput";

export default {
    name: "RecordVideoCompensation",
    components: { VideoInput},
    data () {
        return {
            video: null,
            fileVideo: null,
            visible: false,
            view: false,
            onSave: null,
            onSkip: null,
            onBack: null
        };
    },
    created () {

    },
    methods: {
        uploadPresentationVideo (file, video) {
            this.video = video;
            this.fileVideo = file;
        },
        next () {
            this.$emit("update", {});
        },
        back () {
            this.fileVideo = null;
            this.video = null;
            this.$emit("back", {});
        },
        saveVideo ()  {
            this.$emit("save", {video: this.fileVideo});
            // this.fileVideo = null;
            // this.video = null;
            this.$emit("update", {});
        },
        skipVideoStep () {
            if (this.$data.onSkip) {
                this.$data.onSkip();
            }
            this.visible = false;
            this.fileVideo = null;
            this.video = null;
        },
        handleCallbacks (event) {
            if (typeof event.save === 'function') {
                this.$data.onSave = event.save;
            }
            if (typeof event.skip === 'function') {
                this.$data.onSkip = event.skip;
            }
            if (typeof event.back === 'function') {
                this.$data.onBack = event.back;
            }
        }
    }
};
</script>

<style scoped>
.video-container {
    margin-top: 10px;
    width: 100%;
    flex-grow: 1;
    margin-bottom: 10px;
    height: fit-content;
    min-height: 170px;
}
.video-container .video-frame{
    width: 100%;
}
</style>
